import { useContext, useState, useRef, useEffect } from 'react'
import ResizableModal from '../../../../ui/ResizableModal'
import { Button, Title, Text } from '../../../../ui'
import GlobalContext from '../../../../../../context/global-context'
import { BusinessAPI } from '../../../../../../api/business.api'
import { sileo } from 'sileo'
import Stepper from '@mui/material/Stepper'
import Step from '@mui/material/Step'
import StepLabel from '@mui/material/StepLabel'
import Box from '@mui/material/Box'
import Dialog from '@mui/material/Dialog'
import { btnStyles } from './styles'

// Importación de imágenes para el tutorial
import getnetStep1 from '../../../../../../assets/transactions/getnet/getnet.png'

// Ventas
import getnetVentaStep2 from '../../../../../../assets/transactions/getnet/getnet_ventas_step_1.png'
import getnetVentaStep3 from '../../../../../../assets/transactions/getnet/getnet_ventas_step_2.png'
import getnetVentaStep4 from '../../../../../../assets/transactions/getnet/getnet_ventas_step_3.png'
import getnetVentaStep5 from '../../../../../../assets/transactions/getnet/getnet_ventas_step_4.png'

// Transbank
import transbankStep1 from '../../../../../../assets/transactions/transbank/step_1.png'
import transbankStep2 from '../../../../../../assets/transactions/transbank/step_2.png'
import transbankStep3 from '../../../../../../assets/transactions/transbank/step_3.png'
import transbankStep4 from '../../../../../../assets/transactions/transbank/step_4.png'

import uploadIcon from '../../../../../../assets/upload.png'

const ModalCargarPagosDigitales = ({
  open,
  setOpen,
  onUploadComplete,
  defaultType = 'ventas',
  allowedTypes = ['ventas', 'cartola']
}) => {
  const [tipoTransaccion, setTipoTransaccion] = useState(defaultType)
  const [errorMessage, setErrorMessage] = useState(null)

  useEffect(() => {
    if (open) {
      setTipoTransaccion(defaultType)
    }
  }, [open, defaultType])

  const [activeStep, setActiveStep] = useState(0)
  const [archivoExcel, setArchivoExcel] = useState(null)
  const [skippingTutorial, setSkippingTutorial] = useState(false)
  const [isUploading, setIsUploading] = useState(false)
  const [zoomedImage, setZoomedImage] = useState(null)
  const fileInputRef = useRef(null)
  const { currentBusiness } = useContext(GlobalContext)
  const businessAPI = new BusinessAPI()

  const getSteps = () => {
    if (tipoTransaccion === 'cartola') {
      const transbankSteps = [
        {
          label: 'Portal Transbank',
          description: 'Ingresa al portal de Transbank con tus credenciales.',
          image: transbankStep1
        },
        {
          label: 'Seleccionar Mis Ventas',
          description: 'Haz click en el boton Mis Ventas en el panel lateral.',
          image: transbankStep2
        },
        {
          label: 'Selecciona Cartola de movimientos',
          description: [
            'Filtra la información de la siguiente manera:',
            '• Fecha de venta: ingresar fechas deseadas',
            '• Codigo o nombre del comercio: Todos los locales seleccionados',
            '• Medio de pago: Todos los medios de pago',
            'Luego haz clic en la lupa de búsqueda'
          ],
          image: transbankStep3
        },
        {
          label: 'Descargar Excel',
          description: 'Presiona el botón Descargar para obtener el excel',
          image: transbankStep4
        },
        {
          label: 'Cargar Archivo',
          description: 'Escoge o arrastra el archivo de Transbank aquí.',
          image: null
        }
      ]

      return [
        {
          label: 'Cartola Transbank',
          description: 'Selecciona cómo deseas proceder con tu cartola Transbank',
          image: null,
          isSelection: true
        },
        ...transbankSteps
      ]
    }

    // For Getnet, we only handle Ventas now
    const getnetSteps = [
      {
        label: 'Portal Getnet',
        description: 'Ingresa al portal de Getnet con tus credenciales.',
        image: getnetStep1
      },
      {
        label: 'Seleccionar transacciones',
        description: 'Haz click en el boton transacciones',
        image: getnetVentaStep2
      },
      {
        label: 'Filtrar Periodo',
        description: [
          'Filtra los documentos con estas opciones:',
          '• FILTRAR PERIODO: Este mes',
          '• ESTADO TRANSACCIÓN: Aprobada',
          '• ESTADO: Todo',
          '• LOCAL: Seleccionar todos',
          '• Terminal: Todos'
        ],
        image: getnetVentaStep3
      },
      {
        label: 'Seleccionar archivos',
        description: 'Haz click en el boton de exportar excel en la parte inferior derecha',
        image: getnetVentaStep4
      },
      {
        label: 'Descargar Excel',
        description: 'Haz click en Todas las páginas para descargar los archivos correspondientes.',
        image: getnetVentaStep5
      },
      {
        label: 'Cargar Archivo',
        description: 'Escoge o arrastra un archivo aquí para procesar tus transacciones.',
        image: null
      }
    ]

    return [
      {
        label: 'Tipo de Reporte',
        description: 'Selecciona el tipo de reporte Getnet para subir a Luca',
        image: null,
        isSelection: true
      },
      ...getnetSteps
    ]
  }

  const getStepIcon = (size = 'large') => {
    switch (tipoTransaccion) {
      case 'ventas':
        return (
          <div
            className={`${
              size === 'large' ? 'w-12 h-12' : 'w-8 h-8'
            } rounded-full bg-primary flex items-center justify-center shadow-sm`}
          >
            <svg
              className={`${size === 'large' ? 'w-6 h-6' : 'w-4 h-4'} text-white`}
              fill='none'
              stroke='currentColor'
              viewBox='0 0 24 24'
            >
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth={2}
                d='M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z'
              />
            </svg>
          </div>
        )
      case 'cartola':
        return (
          <div
            className={`${
              size === 'large' ? 'w-12 h-12' : 'w-8 h-8'
            } rounded-full bg-primary flex items-center justify-center shadow-sm`}
          >
            <svg
              className={`${size === 'large' ? 'w-6 h-6' : 'w-4 h-4'} text-white`}
              fill='none'
              stroke='currentColor'
              viewBox='0 0 24 24'
            >
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth={2}
                d='M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z'
              />
            </svg>
          </div>
        )
      default:
        return null
    }
  }

  const steps = getSteps()

  const handleClose = () => {
    setTipoTransaccion(defaultType)
    setArchivoExcel(null)
    setErrorMessage(null)
    setActiveStep(0)
    setSkippingTutorial(false)
    setOpen(false)
  }

  const handleNext = () => {
    setActiveStep(prevActiveStep => prevActiveStep + 1)
  }

  const handleBack = () => {
    if (skippingTutorial) {
      setActiveStep(0)
      setSkippingTutorial(false)
    } else {
      setActiveStep(prevActiveStep => prevActiveStep - 1)
    }
  }

  const handleFileChange = e => {
    if (e.target.files[0]) {
      setArchivoExcel(e.target.files[0])
      setErrorMessage(null)
    }
  }

  const handleRemoveFile = () => {
    setArchivoExcel(null)
    setErrorMessage(null)
    if (fileInputRef.current) {
      fileInputRef.current.value = ''
    }
  }

  const handleGuardar = async () => {
    if (!archivoExcel) {
      sileo.error({
        title: 'Archivo Requerido',
        description: (
          <span className='text-red-500/80 font-medium'>Primero debes subir un archivo excel</span>
        )
      })
      return
    }

    setIsUploading(true)
    setErrorMessage(null)
    // sileo does not have a manual loading handle like toast.loading(toastId),
    // we will use sileo.promise or manual success/error calls.
    // For now, removing toast.loading and replacing update calls with sileo calls.

    try {
      let response
      switch (tipoTransaccion) {
        case 'ventas':
          response = await businessAPI.uploadVentas(
            currentBusiness.id,
            currentBusiness.organizationId,
            archivoExcel
          )
          break
        case 'cartola':
          response = await businessAPI.uploadCartola(
            currentBusiness.id,
            currentBusiness.organizationId,
            archivoExcel
          )
          break
        default:
          throw new Error('Tipo de transacción no válido')
      }

      const { inserted, updated, errors } = response.data

      const getDisplayName = type => {
        switch (type) {
          case 'ventas':
            return 'Getnet Ventas'
          case 'cartola':
            return 'Transbank'
          default:
            return 'reporte'
        }
      }

      const displayName = getDisplayName(tipoTransaccion)

      if (errors > 0) {
        sileo.success({
          title: 'Carga con Observaciones',
          description: (
            <div className='flex flex-col gap-1'>
              <span className='text-green-500/80 font-medium'>Carga de {displayName} completa</span>
              <span className='text-xs text-slate-500'>
                {inserted} nuevos, {updated} actualizados,{' '}
                <span className='text-red-400 font-bold'>{errors} errores</span>
              </span>
            </div>
          )
        })
      } else {
        sileo.success({
          title: 'Carga Exitosa',
          description: (
            <div className='flex flex-col gap-1'>
              <span className='text-green-500/80 font-medium'>
                Carga de {displayName} finalizada
              </span>
              <span className='text-xs text-slate-500'>
                {inserted} nuevos, {updated} actualizados
              </span>
            </div>
          )
        })
      }

      if (onUploadComplete) {
        onUploadComplete()
      }
      handleClose()
    } catch (error) {
      console.error('Error al cargar archivo:', error)
      if (error.response?.status === 400) {
        setErrorMessage(error.response?.data?.message || 'Error al subir archivo')
        setErrorMessage(error.response?.data?.message || 'Error al subir archivo')
      } else {
        sileo.error({
          title: 'Error de Carga',
          description: (
            <span className='text-red-500/80 font-medium'>
              {error.response?.data?.message || 'Error al subir archivo'}
            </span>
          )
        })
      }
    } finally {
      setIsUploading(false)
    }
  }

  const handleMinimize = () => {
    sileo.info({
      title: 'Proceso en Segundo Plano',
      description: (
        <span className='text-blue-500/80 font-medium'>
          La carga seguirá procesándose. Puedes cerrar esta pestaña si lo deseas.
        </span>
      )
    })
    setOpen(false)
  }

  const renderTutorial = () => {
    const isSelectionStep = steps[activeStep]?.isSelection

    return (
      <div className='mb-8'>
        {!isSelectionStep && !skippingTutorial && (
          <Stepper activeStep={activeStep} alternativeLabel className='mb-6'>
            {steps.map((step, index) => (
              <Step key={step.label}>
                <StepLabel
                  StepIconComponent={props => (
                    <div
                      className={`w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold transition-all cursor-pointer ${
                        props.active || props.completed
                          ? 'bg-primary text-white shadow-sm'
                          : 'bg-gray-100 text-gray-400 hover:bg-gray-200'
                      }`}
                      onClick={() => setActiveStep(index)}
                    >
                      {props.icon}
                    </div>
                  )}
                >
                  <span
                    className={`text-[10px] uppercase tracking-wider font-bold transition-colors cursor-pointer ${
                      activeStep === index ? 'text-primary' : 'text-gray-400 hover:text-gray-600'
                    }`}
                    onClick={() => setActiveStep(index)}
                  >
                    {step.label}
                  </span>
                </StepLabel>
              </Step>
            ))}
          </Stepper>
        )}

        <div className='bg-white rounded-3xl shadow-sm overflow-hidden flex flex-col items-center border border-gray-200 relative'>
          {steps[activeStep].image && (
            <div className='w-full p-4 border-b border-gray-50'>
              {Array.isArray(steps[activeStep].description) ? (
                <div className='text-sm font-semibold text-gray-800 max-w-2xl mx-auto'>
                  <div className='text-center mb-4 text-base font-black text-gray-900'>
                    {steps[activeStep].description[0]}
                  </div>
                  <div className='bg-primary/5 rounded-2xl p-5 space-y-3 border border-primary/10'>
                    {steps[activeStep].description.slice(1).map((line, idx) => {
                      const hasColon = line.includes(':')
                      const [label, value] = line.replace('• ', '').split(':')

                      if (!hasColon) {
                        return (
                          <div
                            key={idx}
                            className='bg-primary/10 rounded-xl p-3 flex items-center gap-3 border border-primary/20'
                          >
                            <div className='w-1.5 h-1.5 rounded-full bg-primary flex-shrink-0'></div>
                            <span className='text-primary font-semibold text-sm tracking-tight font-body italic'>
                              {line.replace('• ', '')}
                            </span>
                          </div>
                        )
                      }

                      return (
                        <div
                          key={idx}
                            className='flex items-center gap-3 bg-white rounded-xl p-3 border border-gray-100'
                        >
                          <div className='flex-shrink-0 w-2 h-2 rounded-full bg-primary'></div>
                          <div className='flex-1 flex items-center justify-between gap-3 flex-wrap'>
                            <span className='font-bold text-gray-500 text-[10px] uppercase tracking-wider'>
                              {label.trim()}:
                            </span>
                            <span className='inline-block px-3 py-1 bg-primary text-white text-[11px] font-bold rounded-lg min-w-[120px] text-center'>
                              {value?.trim()}
                            </span>
                          </div>
                        </div>
                      )
                    })}
                  </div>
                </div>
              ) : (
                <Text className='text-sm font-semibold text-gray-800 text-center'>
                  {steps[activeStep].description}
                </Text>
              )}
            </div>
          )}

          {steps[activeStep].image ? (
            <div
              className='p-4 w-full flex justify-center cursor-zoom-in mb-4'
              onClick={() => setZoomedImage(steps[activeStep].image)}
            >
              <img
                src={steps[activeStep].image}
                alt={steps[activeStep].label}
                className='max-w-full h-auto rounded shadow-lg max-h-[400px] object-contain transition-transform hover:scale-[1.01]'
              />
            </div>
          ) : steps[activeStep].isSelection ? (
            <div className='p-5 sm:p-8 w-full flex flex-col items-center justify-center bg-gray-50/60 min-h-[400px]'>
              <div className='w-full max-w-lg'>
                {tipoTransaccion === 'cartola' ? (
                  <div
                    onClick={() => {
                      setActiveStep(steps.length - 1)
                      setArchivoExcel(null)
                      setSkippingTutorial(true)
                    }}
                    className='group bg-white rounded-2xl p-6 sm:p-8 border border-gray-200 shadow-sm hover:border-primary/40 transition-colors cursor-pointer'
                  >
                    <div className='flex items-center gap-5 mb-8'>
                      <div className='w-16 h-16 rounded-2xl bg-primary flex items-center justify-center shadow-sm'>
                        <svg
                          className='w-10 h-10 text-white'
                          fill='none'
                          stroke='currentColor'
                          viewBox='0 0 24 24'
                        >
                          <path
                            strokeLinecap='round'
                            strokeLinejoin='round'
                            strokeWidth={2}
                            d='M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z'
                          />
                        </svg>
                      </div>
                      <div>
                        <h3 className='text-2xl font-black text-gray-900 tracking-tight'>
                          Cartola Transbank
                        </h3>
                        <span className='text-xs font-bold text-primary bg-primary/10 px-3 py-1 rounded-full uppercase'>
                          Ventas y Abonos
                        </span>
                      </div>
                    </div>
                    <p className='text-gray-600 leading-relaxed mb-7 text-sm sm:text-base'>
                      Resumen de <strong>ventas y abonos</strong> procesados por Transbank. Permite
                      conciliar tus pagos recibidos.
                    </p>

                    <div className='flex flex-col gap-4'>
                      <button
                        onClick={e => {
                          e.stopPropagation()
                          setActiveStep(1)
                          setArchivoExcel(null)
                          setSkippingTutorial(false)
                        }}
                        className={btnStyles.cardInstruction}
                      >
                        <svg
                          className='w-5 h-5 text-gray-400'
                          fill='none'
                          stroke='currentColor'
                          viewBox='0 0 24 24'
                        >
                          <path
                            strokeLinecap='round'
                            strokeLinejoin='round'
                            strokeWidth={2}
                            d='M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z'
                          />
                        </svg>
                        Ver instrucciones de descarga
                      </button>
                      <button
                        onClick={e => {
                          e.stopPropagation()
                          setActiveStep(steps.length - 1)
                          setArchivoExcel(null)
                          setSkippingTutorial(true)
                        }}
                        className={btnStyles.cardActionFuchsia}
                      >
                        <svg
                          className='w-5 h-5'
                          fill='none'
                          stroke='currentColor'
                          viewBox='0 0 24 24'
                        >
                          <path
                            strokeLinecap='round'
                            strokeLinejoin='round'
                            strokeWidth={2}
                            d='M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12'
                          />
                        </svg>
                        CARGAR ARCHIVO AHORA
                      </button>
                    </div>
                  </div>
                ) : (
                  <div
                    onClick={() => {
                      setTipoTransaccion('ventas')
                      setActiveStep(steps.length - 1)
                      setArchivoExcel(null)
                      setSkippingTutorial(true)
                    }}
                    className='group bg-white rounded-2xl p-6 sm:p-8 border border-gray-200 shadow-sm hover:border-primary/40 transition-colors cursor-pointer'
                  >
                    <div className='flex items-center gap-5 mb-8'>
                      <div className='w-16 h-16 rounded-2xl bg-primary flex items-center justify-center shadow-sm'>
                        <svg
                          className='w-10 h-10 text-white'
                          fill='none'
                          stroke='currentColor'
                          viewBox='0 0 24 24'
                        >
                          <path
                            strokeLinecap='round'
                            strokeLinejoin='round'
                            strokeWidth={2}
                            d='M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z'
                          />
                        </svg>
                      </div>
                      <div>
                        <h3 className='text-2xl font-black text-gray-900 tracking-tight'>
                          Getnet Ventas
                        </h3>
                        <span className='text-xs font-bold text-primary bg-primary/10 px-3 py-1 rounded-full uppercase'>
                          Venta Diaria
                        </span>
                      </div>
                    </div>
                    <p className='text-gray-600 leading-relaxed mb-7 text-sm sm:text-base'>
                      Reporte con el detalle de todas tus <strong>ventas diarias</strong>. Muestra
                      propinas, cuotas y tipos de tarjeta.
                    </p>

                    <div className='flex flex-col gap-4'>
                      <button
                        onClick={e => {
                          e.stopPropagation()
                          setTipoTransaccion('ventas')
                          setActiveStep(1)
                          setArchivoExcel(null)
                          setSkippingTutorial(false)
                        }}
                        className={btnStyles.cardInstruction}
                      >
                        <svg
                          className='w-5 h-5 text-gray-400'
                          fill='none'
                          stroke='currentColor'
                          viewBox='0 0 24 24'
                        >
                          <path
                            strokeLinecap='round'
                            strokeLinejoin='round'
                            strokeWidth={2}
                            d='M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z'
                          />
                        </svg>
                        Ver instrucciones de descarga
                      </button>
                      <button
                        onClick={e => {
                          e.stopPropagation()
                          setTipoTransaccion('ventas')
                          setActiveStep(steps.length - 1)
                          setArchivoExcel(null)
                          setSkippingTutorial(true)
                        }}
                        className={btnStyles.cardAction('red')}
                      >
                        <svg
                          className='w-5 h-5'
                          fill='none'
                          stroke='currentColor'
                          viewBox='0 0 24 24'
                        >
                          <path
                            strokeLinecap='round'
                            strokeLinejoin='round'
                            strokeWidth={2}
                            d='M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12'
                          />
                        </svg>
                        CARGAR REPORTE AHORA
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div className='p-5 sm:p-8 w-full flex flex-col items-center justify-center bg-gray-50/60'>
              {!steps[activeStep].image && !Array.isArray(steps[activeStep].description) && (
                <div className='mb-6 max-w-lg w-full'>
                  <Text className='text-sm font-bold text-gray-800 text-center mb-4 uppercase tracking-wider'>
                    {steps[activeStep].description}
                  </Text>
                </div>
              )}
              <div
                className={`relative w-full max-w-lg p-8 border-2 border-dashed rounded-2xl flex flex-col items-center justify-center cursor-pointer transition-colors ${
                  archivoExcel
                    ? 'border-green-500 bg-green-50/50 shadow-inner'
                    : 'border-primary/40 bg-white hover:bg-primary/5'
                }`}
                onClick={() => fileInputRef.current?.click()}
                onDragOver={e => e.preventDefault()}
                onDrop={e => {
                  e.preventDefault()
                  if (e.dataTransfer.files[0]) {
                    setArchivoExcel(e.dataTransfer.files[0])
                  }
                }}
              >
                {archivoExcel && (
                  <button
                    onClick={e => {
                      e.stopPropagation()
                      handleRemoveFile()
                    }}
                    className='absolute top-4 right-4 p-2 rounded-full bg-white hover:bg-red-50 text-gray-400 hover:text-red-500 shadow-sm transition-all border border-gray-100'
                  >
                    <svg className='w-5 h-5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                      <path
                        strokeLinecap='round'
                        strokeLinejoin='round'
                        strokeWidth={2.5}
                        d='M6 18L18 6M6 6l12 12'
                      />
                    </svg>
                  </button>
                )}
                <div
                  className={`w-16 h-16 rounded-2xl flex items-center justify-center mb-4 transition-all ${
                    archivoExcel
                      ? 'bg-green-500 text-white shadow-lg rotate-12'
                      : 'bg-primary text-white shadow-sm'
                  }`}
                >
                  <img src={uploadIcon} alt='upload' className='w-8 h-8 brightness-0 invert' />
                </div>
                <Text className='text-lg font-black text-gray-900 mb-1'>
                  {archivoExcel ? 'Se seleccionó el archivo' : 'Haz click para subir archivo'}
                </Text>
                <Text className='text-sm text-gray-500 text-center truncate w-full px-6'>
                  {archivoExcel
                    ? archivoExcel.name
                    : 'Arrastra tu archivo Excel aquí (.xlsx, .xls)'}
                </Text>
                <input
                  type='file'
                  ref={fileInputRef}
                  accept='.xlsx,.xls'
                  className='hidden'
                  onChange={handleFileChange}
                />
              </div>

              <div className='mt-6 flex items-center gap-3 text-gray-400 bg-white px-5 py-2.5 rounded-full border border-gray-100'>
                <div className='w-2 h-2 rounded-full bg-primary animate-ping'></div>
                <p className='text-[10px] font-black tracking-[0.1em] uppercase'>
                  Luca procesa tus datos sin crear duplicidades
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }

  return (
    <ResizableModal
      open={open}
      onClose={isUploading ? handleMinimize : handleClose}
      onMinimize={isUploading ? handleMinimize : null}
      footer={
        <Box
          sx={{
            display: 'flex',
            width: '100%',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <Box>
            {activeStep > 0 && !isUploading && (
              <Button onClick={handleBack} className={btnStyles.outline} title='ATRÁS' />
            )}
          </Box>

          <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
            {isUploading ? (
              <>
                <div className='flex items-center gap-2 text-primary font-bold animate-pulse mr-4'>
                  <span className='relative flex h-3 w-3'>
                    <span className='animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75'></span>
                    <span className='relative inline-flex rounded-full h-3 w-3 bg-primary'></span>
                  </span>
                  <Text className='text-xs'>Procesando información en segundo plano...</Text>
                </div>
                <Button
                  onClick={handleMinimize}
                  className={btnStyles.secondary}
                  title='MINIMIZAR'
                />
              </>
            ) : (
              <>
                {activeStep < steps.length - 1 ? (
                  !steps[activeStep]?.isSelection && (
                    <div className='flex gap-2'>
                      <Button
                        onClick={() => {
                          setActiveStep(steps.length - 1)
                          setSkippingTutorial(true)
                        }}
                        className={btnStyles.ghost}
                        title='OMITIR TUTORIAL'
                      />
                      <Button
                        onClick={handleNext}
                        className={btnStyles.primary}
                        title='SIGUIENTE'
                      />
                    </div>
                  )
                ) : (
                  <Button
                    onClick={handleGuardar}
                    className={btnStyles.primary}
                    title='SUBIR ARCHIVO'
                  />
                )}
              </>
            )}
          </Box>
        </Box>
      }
    >
      <div className='relative w-full mx-auto max-w-4xl py-1 font-sans'>
        {!steps[activeStep]?.isSelection && (
          <div className='flex flex-col items-center mb-6'>
            <div className='mb-3 hover:scale-110 transition-transform duration-300'>
              {getStepIcon('large')}
            </div>
            <Title className='text-xl sm:text-2xl font-bold text-gray-900 mb-1'>
              {activeStep === steps.length - 1
                ? `Carga el reporte de ${
                    tipoTransaccion === 'cartola' ? 'Transbank' : 'Getnet Ventas'
                  }`
                : '¿Cómo descargar el reporte?'}
            </Title>
            <Text className='text-gray-500 text-sm'>
              {activeStep === steps.length - 1
                ? 'Selecciona o arrastra el archivo Excel para procesar tus transacciones'
                : 'Sigue estos simples pasos para cargar tus movimientos'}
            </Text>
          </div>
        )}

        {steps[activeStep]?.isSelection && (
          <div className='text-center mb-6'>
            <Title className='text-2xl sm:text-3xl font-bold text-gray-900 mb-2'>
              {tipoTransaccion === 'cartola'
                ? 'Carga de transacciones de Transbank'
                : 'Carga de Pagos Digitales de Getnet'}
            </Title>
          </div>
        )}

        {renderTutorial()}

        {errorMessage && (
          <div className='flex items-center justify-center gap-2 mb-6'>
            <div className='bg-red-50 text-red-800 px-6 py-4 rounded-2xl flex items-start gap-4 border border-red-100 w-full max-w-2xl shadow-sm'>
              <div className='flex-shrink-0 mt-0.5'>
                <svg
                  className='w-6 h-6 text-red-500'
                  fill='none'
                  stroke='currentColor'
                  viewBox='0 0 24 24'
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth={2}
                    d='M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z'
                  />
                </svg>
              </div>
              <div className='flex-1'>
                <p className='text-sm font-bold text-red-900 mb-1 uppercase tracking-tight'>
                  Error en el archivo
                </p>
                <p className='text-sm font-medium leading-relaxed italic'>{errorMessage}</p>
              </div>
            </div>
          </div>
        )}

        {archivoExcel && !errorMessage && (
          <div className='flex items-center justify-center gap-2 mb-4'>
            <div className='bg-green-100 text-green-700 px-4 py-1.5 rounded-full text-xs font-black flex items-center gap-2 border border-green-200'>
              Archivo listo: {archivoExcel.name}
              <button
                onClick={handleRemoveFile}
                className='ml-1 hover:bg-green-200 rounded-full p-0.5 transition-colors flex items-center justify-center'
                title='Eliminar archivo'
              >
                <svg className='w-3.5 h-3.5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth={2}
                    d='M6 18L18 6M6 6l12 12'
                  />
                </svg>
              </button>
            </div>
          </div>
        )}
      </div>

      <Dialog
        open={!!zoomedImage}
        onClose={() => setZoomedImage(null)}
        maxWidth='lg'
        PaperProps={{
          style: {
            backgroundColor: 'transparent',
            boxShadow: 'none',
            overflow: 'hidden'
          }
        }}
      >
        <div
          className='relative p-2 flex justify-center items-center'
          onClick={() => setZoomedImage(null)}
        >
          <img
            src={zoomedImage}
            alt='Zoom'
            className='max-w-full max-h-[90vh] rounded-lg shadow-2xl cursor-zoom-out'
          />
        </div>
      </Dialog>
    </ResizableModal>
  )
}

export default ModalCargarPagosDigitales
